import React from 'react';
import PropTypes from 'prop-types';
import { getShortDateFormat } from 'helpers/DateHelper';
import { makeStyles } from 'styles/util';
import strings from 'localization/strings';
import { required, email } from 'form/validation';

import Box from '@material-ui/core/Box';
import { TextField, showErrorOnBlur } from 'mui-rff';
import NullableDatePicker from 'form/NullableDatePicker';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

const useStyles = makeStyles(({ theme }) => ({
    storageSiteLockSystemUserContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2)
    },
    nameContainer: {
        flex: '1 1 20%'
    },
    descriptionContainer: {
        flex: '1 1 20%'
    },
    lockSystemUserIdentifierContainer: {
        flex: '1 1 20%'
    },
    startDateContainer: {
        flex: '1 1 15%'
    },
    endDateContainer: {
        flex: '1 1 15%'
    },
    removeButtonContainer: {
        flex: '0 0 auto'
    },
    small: {
        fontSize: '85%'
    }
}));

const StorageSiteLockSystemUserEditor = ({ fieldNamePrefix, onRemove }) => {
    const classes = useStyles();

    const getName = suffix => suffix ? `${fieldNamePrefix}.${suffix}` : fieldNamePrefix;

    return (
        <Box className={classes.storageSiteLockSystemUserContainer}>
            <Box className={classes.nameContainer}>
                <TextField
                    name={getName('name')}
                    size="small"
                    className={classes.small}
                    label={strings.name}
                    variant="outlined"
                    showError={showErrorOnBlur}
                    required
                    fieldProps={{ validate: required }}
                />
            </Box>

            <Box className={classes.descriptionContainer}>
                <TextField
                    name={getName('description')}
                    size="small"
                    className={classes.small}
                    label={strings.description}
                    variant="outlined"
                />
            </Box>

            <Box className={classes.lockSystemUserIdentifierContainer}>
                <TextField
                    name={getName('lockSystemUserIdentifier')}
                    size="small"
                    className={classes.small}
                    label={strings.email}
                    variant="outlined"
                    showError={showErrorOnBlur}
                    required
                    fieldProps={{ validate: email }}
                />
            </Box>

            <Box className={classes.startDateContainer}>
                <NullableDatePicker
                    name={getName('startDate')}
                    size="small"
                    className={classes.small}
                    label={strings.startDate}
                    formatFunc={getShortDateFormat}
                    nullString={strings.noLimitation}
                    nullButtonLabel={strings.noLimitation}
                    inputVariant="outlined"
                />
            </Box>

            <Box className={classes.endDateContainer}>
                <NullableDatePicker
                    name={getName('endDate')}
                    size="small"
                    className={classes.small}
                    label={strings.endDate}
                    formatFunc={getShortDateFormat}
                    nullString={strings.noLimitation}
                    nullButtonLabel={strings.noLimitation}
                    inputVariant="outlined"
                />
            </Box>

            <Box className={classes.removeButtonContainer}>
                <IconButton
                    onClick={onRemove}
                >
                    <DeleteOutlineOutlinedIcon/>
                </IconButton>
            </Box>
        </Box>
    );
};

StorageSiteLockSystemUserEditor.propTypes = {
    fieldNamePrefix: PropTypes.string.isRequired,
    onRemove: PropTypes.func.isRequired
};

export default StorageSiteLockSystemUserEditor;
